export default function updateRecord (list, payload, push = true) {
  const { id } = payload
  let index

  const record = list.find((item, idx) => {
    index = idx
    return item.id === id
  })

  if (record) {
    list.splice(index, 1, Object.assign({}, record, payload))
  } else if (push) {
    list.push(payload)
  }
}
